.g2{border:1px solid #ddd;}